export default "__VITE_ASSET__BpDMcPj1__"